export default "__VITE_ASSET__ONt3dQ5a__"